// extracted by mini-css-extract-plugin
export default {"educationItem":"Education_educationItem__UT08s"};